import React from 'react';
import PropTypes from 'prop-types';
import root from 'window-or-global';

class UpButton extends React.PureComponent {
    static propTypes = {
        buttonMargin: PropTypes.bool,
        onClick: PropTypes.func
    };

    scrollUp = (e) => {
        if (this.props.onClick && typeof this.props.onClick === 'function') {
            this.props.onClick(e);
            return;
        }
        root.document.body.scrollTop = 0;
        root.document.documentElement.scrollTop = 0;
    };

    render() {
        return (
            <div className="col-xs-2 col-sm-4 pull-right">
                <button
                    className={`up-button text-color-nonactive-border accent-color-hover-border ${this.props.buttonMargin ? 'bot-margin' : ''}`}
                    onClick={this.scrollUp}>
                    <span className="eg-footer-icon-carrot text-color-nonactive accent-color-hover" />
                </button>
            </div>
        );
    }
}

export default UpButton;
